// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"611":"054e01c6","677":"7088e5a9","901":"558bb993"}[chunkId] + ".chunk.css";
};